

function highlightArtwork(evt) {

    let mainNode = this.parentNode;

    mainNode.classList.toggle('--hover');
    document.body.classList.toggle('--fade');

    let author = document.querySelector('#selected-author');
    
    author.textContent = mainNode.querySelector('span').textContent;

    if (evt.type == 'mouseenter') {
        updateBodyColor(mainNode.getAttribute('data-bgcolor'));
    }

    if (evt.type == 'mouseleave') {
        document.body.removeAttribute('style');
    }
}



    
document.addEventListener('DOMContentLoaded', function() {

    if (desktopScreen.matches) {

        if (document.querySelectorAll('.artworks-list').length > 0) {

            let elements = this.documentElement.querySelectorAll('.artworks-list li a');

            
            elements.forEach(function(el, idx) {      
                // hover handlers
                el.querySelector('img').addEventListener('mouseenter', highlightArtwork);
                el.querySelector('img').addEventListener('mouseleave', highlightArtwork);
            });

            /*
            const gallery = document.querySelector('.current .artworks-list');

            //document.querySelector('.artworks-list').addEventListener('mousemove', (e) => {
            document.querySelector('main').addEventListener('mousemove', (e) => {

                const main = document.querySelector('main');

                const
                    mouseX = e.clientX,
                    mouseY = e.clientY;
                
                const
                    deltaX = gallery.offsetWidth - window.innerWidth,
                    deltaY = gallery.offsetHeight - window.innerHeight + gallery.offsetTop; // include <main> top padding

                const
                    xDecimal = mouseX / window.innerWidth,
                    yDecimal = mouseY / window.innerHeight;
                
                console.log(xDecimal + ' , ' + yDecimal);
                
                const
                    panX = (deltaX > 0) ? deltaX * xDecimal * -1 : 0,
                    panY = (deltaY > 0) ? deltaY * yDecimal * -1 : 0;

                
                gallery.animate({
                    transform: 'translate(' + panX + 'px, ' + panY + 'px)'
                }, {
                    duration: 800,
                    fill: "forwards",
                    easing: "ease"
                });
            });
            */
        }
        
    }
});


